<template>
  <div @click="show = false">
    <topnavbar :show="show" @toggle="toggle"></topnavbar>
    <vue-final-modal
      v-model="event.isPrivate && !isLoading && !passcodeVerify"
      classes="modal-container3"
      content-class="modal-content3"
    >
      <privateEvent
        @closeModel="closeModel"
        :event="event"
        @passcodeVerified="passcodeVerified"
      ></privateEvent>
    </vue-final-modal>
    <vue-final-modal
      v-model="showModel"
      classes="modal-container1"
      content-class="modal-content1"
    >
      <unauthorizedUser @closepopup="closeModel" @setLoader="setLoader" />
    </vue-final-modal>
    <vue-element-loading
      :active="isLoading"
      style="z-index: 42 !important; min-height: 60vh"
      text="MYLE"
      :text-style="loadStyle"
      :is-full-screen="false"
      class="
        full-height
        background-overlay
        h-full
        flex
        w-full
        rounded-xl
        flex-col
        md:mx-auto
      "
      spinner="bar-fade-scale"
      color="#ffffff"
    />

    <!-- Banner Section starts -->
    <div
      class="
        w-full
        overflow-hidden
        relative
        items-end
        flex
        bg-gray-800
      "
      id="banner"
    >
      <img
        v-if="false"
        :src="
          `${$APP_CONFIG.BASE_IMAGE_URL}${event.image1 ||
            event.image2 ||
            event.image3}`
        "
        class="absolute filter blur-md z-1"
        style="height: 110%; width: 110%"
        alt=""
      />
      <div
        class="
          w-full
          px-2
          sm:px-0
          overflow-hidden
          relative
          items-end
          flex
          bg-gray-800
          outer-diva
        "
      >
        <img
          :src="
            `${$APP_CONFIG.BASE_IMAGE_URL}${event.image1 ||
              event.image2 ||
              event.image3}`
          "
          class="absolute filter blur-md z-1"
          style="height: 110%; width: 110%"
          alt=""
        />
        <div
          class="
            mx-auto
            w-full
            sm:w-10/12
            bg-cover
            flex
            flex-col
            relative
            bg-no-repeat
            mb-0
            rounded-t-2xl
            overflow-hidden
            inner-diva
          "
        >
          <img
            :src="
              `${$APP_CONFIG.BASE_IMAGE_URL}${event.image1 ||
                event.image2 ||
                event.image3}`
            "
            class="z-10"
            style="margin-top: 4rem;
            position: relative;
            width: 100%;
            height: auto;"
          />

          <a
            v-if="event.video"
            :href="
              'https://storage.googleapis.com/s8w80ukr9zgzqst5era7u9uh1eo5uf81kibwqdsu6j4f1mh7tw/' +
                event.video
            "
            target="_blank"
            class="
              absolute
              w-max
              sm:bottom-4
              top-4
              sm:top-auto
              right-4
              z-30
              cursor-pointer
              items-center
              gap-2
              flex
            "
          >
            <img src="/img/myle/svg/paly.svg" alt="" />
            <span class="sm:text-white text-gray-500">Play Video</span>
          </a>

          <!-- <div class="absolute w-max px-4 h-4  items-center rounded-2xl  z-20 flex gap-1  md:bottom-16 bottom-11 left-0 right-0 m-auto bg-gray-700">
            <div class="w-1.5 h-1.5 bg-white rounded-full flex-1"></div>
            <div class="w-1.5 h-1.5 bg-gray-400 rounded-full flex-1"></div>
            <div class="w-1.5 h-1.5 bg-gray-400 rounded-full flex-1"></div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- Banner Section ends -->

    <!-- Event Section starts -->
    <div
      class="sticky-nav fixed w-full z-40 sm:top-20 top-16 sm:px-0 px-2"
      v-bind:class="{ hidden: !showStickyNav }"
    >
      <div
        class="
          flex flex-wrap
          sm:w-10/12
          mx-auto
          bg-white
          px-2
          py-3
          w-full
          shadow-box
          sm:px-10
        "
      >
        <div class="sm:flex-grow flex-initial truncate">
          <div class="flex gap-2 overflow-hidden truncate">
            <div class="text-3xl text-gray-500 truncate">
              <p class="truncate">{{ event.title || '' }}</p>
            </div>
            <div class="mt-1 2xs:mt-2 float-right">
              <a
                class="
                  rounded-full
                  text-green-800
                  cursor-default
                  2xs:text-sm
                  text-xs
                  bg-gray-300
                  py-1
                  px-3
                  w-max
                "
                >{{ eventStatusVal }}</a
              >
            </div>
          </div>
          <div class="mx-auto block sm:hidden mt-2 sm:mt-0 mb-2">
            <img
              src="/img/myle/svg/ic_priceTagGreen.svg"
              class="h-3 pr-2 inline-block"
              alt=""
            />
            <span class="text-gray-500 inline-block">
              <span
                ><template
                  v-if="
                    event.havePrice &&
                      (event.minimumPrice || event.maximumPrice)
                  "
                >
                  {{
                    event.minimumPrice == '9999' && event.maximumPrice == '9999'
                      ? 'VARIES'
                      : '$' +
                        event.minimumPrice.toFixed(2) +
                        '-' +
                        event.maximumPrice.toFixed(2)
                  }}</template
                ><template v-else>
                  FREE</template
                ></span
              >
            </span>
          </div>
          <p class="sm:mt-3">
                        <i class="fa text-lime text-sm font-bold  fa-hourglass-start mr-1"></i>

            <i class="fa text-lime text-xl font-bold fa-calendar"></i>
            <span class="text-gray-500">
              <span>
                <span class="xs:text-xl text-gray-500">{{
                  offsetDiff(event, 'MMM DD, YYYY')
                }}</span>
                <span class="xs:text-xl text-gray-500 ml-1">{{
                  offsetDiff(event, 'hh:mm A')
                }}</span>
              </span>
            </span>
            <br />

            
            <i
              class="fa text-lime text-sm font-bold fa-hourglass-end mr-1"
              v-if="event.endDateTime"
            ></i>
            <i
              class="fa text-lime text-xl font-bold fa-calendar"
              v-if="event.endDateTime"
            ></i>
            <span class="text-gray-500">
              <span>
                <span
                  class="xs:text-xl ml-1 text-gray-500"
                  v-if="event.endDateTime"
                  >{{ offsetDiffe(event, 'MMM DD, YYYY') }}</span
                >
                <span
                  class="xs:text-xl ml-1 text-gray-500"
                  v-if="event.endDateTime"
                  >{{ offsetDiffe(event, 'hh:mm A') }}</span
                >
              </span>
            </span>
          </p>
        </div>
        <div class="sm:flex-none w-full sm:w-auto flex-initial">
          <div class="mx-auto mt-2 sm:mt-0 mb-2 hidden sm:block ">
            <img
              src="/img/myle/svg/ic_priceTagGreen.svg"
              class="h-3 pr-2 inline-block"
              alt=""
            />
            <span class="text-gray-500 inline-block">
              <span>
                <template
                  v-if="
                    event.havePrice &&
                      (event.minimumPrice || event.maximumPrice)
                  "
                >
                  {{
                    event.minimumPrice == '9999' && event.maximumPrice == '9999'
                      ? 'VARIES'
                      : '$' +
                        event.minimumPrice.toFixed(2) +
                        '-' +
                        event.maximumPrice.toFixed(2)
                  }}
                </template>
                <template v-else
                  >FREE</template
                >
              </span>
            </span>
          </div>
          <div
            class="float-right px-1 pt-2 sm:px-0 sm:pt-0"
            @click="setWarning(true)"
          >
            <a
              v-bind:class="{ 'pointer-events-none': false }"
              v-if="returnUrl"
              :href="returnUrl"
              target="_blank"
              class="
                border-green-900
                text-sm
                sm:text-lg
                font-light
                rounded
                py-2
                px-8
                mr-2
                border
                bg-green-900
                hover:border-green-700
                transition
                ease-in-out
                duration-500
                text-white
                hover:bg-green-700
              "
            >
              {{
                event.eventCode == 'QLf6pBkq4JTOim' ||
                event.eventCode == 'APnZdBDG03Z8aC'
                  ? 'Donate'
                  : 'Get Tickets'
              }}
            </a>

            <a
              v-bind:class="{ 'pointer-events-none': false }"
              v-if="
                event.haveTicket &&
                  event.totalMYLETickets &&
                  Number(event.totalMYLETickets) > 0 &&
                  event.ticketUrl &&
                  event.ticketUrl.length > 0
              "
              :href="
                event.ticketUrl ? event.ticketUrl : '/ticket/' + event.eventCode
              "
              target="_blank"
              class="
                border-green-900
                text-sm
                sm:text-lg
                font-light
                rounded
                py-2
                px-8
                border
                bg-green-900
                hover:border-green-700
                transition
                ease-in-out
                duration-500
                text-white
                hover:bg-green-700
              "
            >
              Redeem Tickets
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Event Section ends -->

    <div
      class="mx-auto w-full sm:w-10/12 px-2 sm:px-0 relative z-20 bg-mute text-green-900"
    >
      <div class="w-full pb-10 relative">
        <div
          class="
                absolute
                w-full
                h-full
                bottom-3
                z-10
              "
        ></div>
        <div class="relative px-3 2xs:px-6 sm:px-10 z-20">
          <h1
            class="2xs:text-5xl text-3xl font-semibold text-green-900 fsize mb-3 pt-4 text-center"
          >
            {{ event.title || '-' }}
          </h1>
          <!-- <p class="py-1 text-white font-light">
                Event code:
                <a @click="clipboard($event, event)" class="text-lime font-semibold underline" style="cursor: pointer !important;"
                  >#{{ event.eventCode || "-" }}</a
                >
              </p> -->
          <p class="text-center">
            <i
              class="
                    fa
                    text-lime
                    xs:text-sm
                    text-sm
                    font-bold
                    fa fa-hourglass-start
                    mr-1
                  "
            ></i> 
            <i
              class="
                    fa
                    text-lime
                    xs:text-2xl
                    text-sm
                    font-bold
                    fa fa-calendar
                  "
            ></i>
            <span class="xs:text-xl text-green-900">{{
              offsetDiff(event, 'MMM DD, YYYY')
            }}</span>
            <span class="xs:text-xl text-green-900 ml-1">{{
              offsetDiff(event, 'hh:mm A')
            }}</span>
            <span class="xs:text-xl text-green-900 ml-1">{{
              ' (' + getZoneName + ')'
            }}</span>
          </p>

          <p class="text-center">
            <i
                          v-if="event.endDateTime"

              class="
                    fa
                    text-lime
                    xs:text-sm
                    text-sm
                    font-bold
                    fa fa-hourglass-end
                    mr-1
                  "
            ></i> 
            <i
              v-if="event.endDateTime"
              class="
                    fa
                    text-lime
                    xs:text-2xl
                    text-sm
                    font-bold
                    fa fa-calendar
                  "
            ></i>
            <span class="xs:text-xl text-green-900" v-if="event.endDateTime">{{
              offsetDiffe(event, 'MMM DD, YYYY')
            }}</span>
            <span
              class="xs:text-xl text-green-900 ml-1"
              v-if="event.endDateTime"
              >{{ offsetDiffe(event, 'hh:mm A') }}</span
            >
            <span
              v-if="event.endDateTime"
              class="xs:text-xl text-green-900 ml-1"
              >{{ ' (' + getZoneName + ')' }}</span
            >
          </p>
        </div>
      </div>

      <div class="bg-mute relative w-full">
        <div class="absolute z-10 w-full ">
          <div class="flex w-max mx-auto gap-6 relative">
            <div
              class="
                bg-lime bg-opacity-40
                rounded-full
                w-14
                h-14
                2xs:w-16 2xs:h-16
                sm:w-20 sm:h-20
                p-2
                hover:scale-110
                transform
                cursor-pointer
                transition
                ease-in-out
                duration-500
              "
            >
              <div
                @click="likeClicked"
                class="bg-lime rounded-full w-full h-full flex items-center"
              >
                <img
                  src="/img/myle/svg/ic_tileLiked.svg"
                  alt=""
                  class="m-auto sm:h-7 h-5 w-8"
                />
              </div>
            </div>
            <div
              class="
                bg-lime bg-opacity-40
                rounded-full
                w-14
                h-14
                2xs:w-16 2xs:h-16
                sm:w-20 sm:h-20
                p-2
                hover:scale-110
                transform
                cursor-pointer
                transition
                ease-in-out
                duration-500
              "
            >
              <div
                @click="loveClicked"
                class="bg-lime rounded-full w-full h-full flex items-center"
              >
                <img
                  src="/img/myle/svg/ic_tileLoved.svg"
                  alt=""
                  class="m-auto sm:h-7 h-5 w-8"
                />
              </div>
            </div>
            <div
              class="
                bg-lime bg-opacity-40
                rounded-full
                w-14
                h-14
                2xs:w-16 2xs:h-16
                sm:w-20 sm:h-20
                p-2
                hover:scale-110
                transform
                cursor-pointer
                transition
                ease-in-out
                duration-500
              "
            >
              <div
                @click="likeClicked"
                class="bg-lime rounded-full w-full h-full flex items-center"
              >
                <img
                  src="/img/myle/svg/ic_tileLiked.svg"
                  alt=""
                  class="m-auto sm:h-7 h-5 transform rotate-180 w-8"
                />
              </div>
            </div>
            <div
              class="
                bg-lime bg-opacity-40
                rounded-full
                w-14
                h-14
                2xs:w-16 2xs:h-16
                sm:w-20 sm:h-20
                p-2
                hover:scale-110
                transform
                cursor-pointer
                transition
                ease-in-out
                duration-500
              "
            >
              <div
                @click="attendingClicked"
                class="bg-lime rounded-full w-full h-full p-3 flex items-center"
              >
                <img
                  src="/img/myle/svg/ic_goingBig.svg"
                  alt=""
                  class="m-auto sm:h-7 h-5 w-8"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="relative">
          <div
            class="
              grid grid-cols-5
              sm:w-max
              mx-auto
              px-3
              xl:gap-10
              sm:gap-6
              gap-2
              pt-24
              pb-8
            "
          >
            <div class="text-gray-400 mx-auto sm:text-xl flex items-center">
              <img
                src="/img/myle/svg/eye.svg"
                alt=""
                class="mr-2 h-4 sm:h-6 green-filter"
              />
              <p>{{ event.totalViewsCount }}</p>
            </div>
            <div class="text-gray-400 mx-auto sm:text-xl flex items-center">
              <img
                src="/img/myle/svg/ic_lowerbarAttending.svg"
                alt=""
                class="mr-2 sm:h-7 h-5 green-filter"
              />
              <p>{{ event.totalAttendingsCount }}</p>
            </div>
            <div class="text-gray-400 mx-auto sm:text-xl flex items-center">
              <img
                src="/img/myle/svg/ic_lowerbarLoved.svg"
                alt=""
                class="mr-2 sm:h-7 h-5 green-filter"
              />
              <p>{{ event.totalLovedCount }}</p>
            </div>
            <div class="text-gray-400 mx-auto sm:text-xl flex items-center">
              <img
                src="/img/myle/svg/ic_lowerBarLiked.svg"
                alt=""
                class="mr-2 sm:h-7 h-5 green-filter"
              />
              <p>{{ event.totalLikesCount }}</p>
            </div>
            <div class="text-gray-400 mx-auto sm:text-xl flex items-center">
              <img
                src="/img/myle/svg/ic_tileChatGrey.svg"
                alt=""
                class="mr-2 sm:h-7 h-5 green-filter"
              />
              <p>{{ event.totalCommentCount }}</p>
            </div>
          </div>

          <div class="absolute hidden md:block right-5 bottom-10">
            <div class="mx-auto mt-2 sm:mt-0 mb-2 hidden sm:block text-right">
              <img
                src="/img/myle/svg/ic_priceTagGreen.svg"
                class="h-3 pr-2 inline-block"
                alt=""
              /><span class="text-gray-500 inline-block">
                <span>
                  <template
                    v-if="
                      event.havePrice &&
                        (event.minimumPrice || event.maximumPrice)
                    "
                  >
                    {{
                      event.minimumPrice == '9999' &&
                      event.maximumPrice == '9999'
                        ? 'VARIES'
                        : '$' +
                          event.minimumPrice.toFixed(2) +
                          '-' +
                          event.maximumPrice.toFixed(2)
                    }}
                  </template>
                  <template v-else
                    >FREE</template
                  >
                </span>
              </span>
            </div>
            <div
              class="float-right px-1 pt-2 sm:px-0 sm:pt-0"
              @click="setWarning(true)"
            >
              <a
                v-bind:class="{ 'pointer-events-none': false }"
                v-if="returnUrl"
                :href="returnUrl"
                target="_blank"
                class="
              border-green-900
              text-sm
              sm:text-lg
              font-light
              rounded
              py-2
              px-8
              mr-2
              border
              bg-green-900
              hover:border-green-700
              transition
              ease-in-out
              duration-500
              text-white
              hover:bg-green-700
              "
              >
                {{
                  event.eventCode == 'QLf6pBkq4JTOim' ||
                  event.eventCode == 'APnZdBDG03Z8aC'
                    ? 'Donate'
                    : 'Get Tickets'
                }}
              </a>
              <a
                v-bind:class="{ 'pointer-events-none': false }"
                v-if="
                  event.haveTicket &&
                    event.totalMYLETickets &&
                    Number(event.totalMYLETickets) > 0 &&
                    event.ticketUrl &&
                    event.ticketUrl.length > 0
                "
                :href="
                  event.ticketUrl
                    ? event.ticketUrl
                    : '/ticket/' + event.eventCode
                "
                target="_blank"
                class="
                  border-green-900
                  text-sm
                  sm:text-lg
                  font-light
                  rounded
                  py-2
                  px-8
                  border
                  bg-green-900
                  hover:border-green-700
                  transition
                  ease-in-out
                  duration-500
                  text-white
                  hover:bg-green-700
                "
              >
                Redeem Tickets
              </a>
            </div>
          </div>
          <div class="block md:hidden text-center">
            <div class="mx-auto mt-2 sm:mt-0 mb-2 sm:block">
              <img
                src="/img/myle/svg/ic_priceTagGreen.svg"
                class="h-3 pr-2 inline-block"
                alt=""
              /><span class="text-gray-500 inline-block">
                <span>
                  <template
                    v-if="
                      event.havePrice &&
                        (event.minimumPrice || event.maximumPrice)
                    "
                  >
                    {{
                      event.minimumPrice == '9999' &&
                      event.maximumPrice == '9999'
                        ? 'VARIES'
                        : '$' +
                          event.minimumPrice.toFixed(2) +
                          '-' +
                          event.maximumPrice.toFixed(2)
                    }}
                  </template>
                  <template v-else
                    >FREE</template
                  >
                </span>
              </span>
            </div>
            <a
              v-if="returnUrl"
              :href="returnUrl"
              target="_blank"
              @click="setWarning(true)"
              class="
                text-center
                border-green-900
                text-sm
                sm:text-lg
                font-light
                rounded
                py-2
                mb-8
                px-8
                border
                bg-green-900
                hover:border-green-700
                transition
                ease-in-out
                duration-500
                text-white
                hover:bg-green-700
              "
            >
              {{
                event.eventCode == 'QLf6pBkq4JTOim' ||
                event.eventCode == 'APnZdBDG03Z8aC'
                  ? 'Donate'
                  : 'Get Tickets'
              }}
            </a>

            <a
              v-if="
                event.haveTicket &&
                  event.totalMYLETickets &&
                  Number(event.totalMYLETickets) > 0 &&
                  event.ticketUrl &&
                  event.ticketUrl.length > 0
              "
              :href="
                event.ticketUrl ? event.ticketUrl : '/ticket/' + event.eventCode
              "
              target="_blank"
              @click="setWarning(true)"
              class="
                text-center
                border-green-900
                text-sm
                sm:text-lg
                font-light
                rounded
                py-2
                mb-8
                px-8
                mr-2
                border
                bg-green-900
                hover:border-green-700
                transition
                ease-in-out
                duration-500
                text-white
                hover:bg-green-700
              "
            >
              Redeem Tickets
            </a>
          </div>
        </div>
      </div>

      <div
        @click="show = false"
        class="w-full sm:mt-0 bg-white px-3 py-8 sm:p-8"
      >
        <p class="w-full text-green-900 text-3xl font-semibold mx-auto mb-8">
          About this event
        </p>
        <div class="flex" v-bind:class="{ 'flex-wrap': innerWidth < 916 }">
          <div
            class="sm:flex-1 flex-initial"
            v-bind:class="{
              'wid-full': innerWidth <= 916,
              'wid-60': innerWidth > 916,
              'wid-50': innerWidth >= 1024,
            }"
          >
            <div class="text-gray-500">
              <div
                style="white-space: break-spaces; word-break: break-word"
                v-html="findUrls(event.longDescription)"
              ></div>
            </div>
            <div class="flex gap-1 my-4 flex-wrap">
              <p
                class="
                  text-white
                  rounded-full
                  font-light
                  text-sm
                  px-3
                  py-1
                  bg-green-800
                "
                v-for="(v, key) in mappedCategories"
                :key="key"
              >
                {{ v.name }}
              </p>
            </div>
            <p
              class="
                w-full
                text-green-900 text-3xl
                font-semibold
                mx-auto
                mt-6
                pt-6
              "
              v-if="timelisting().length"
            >
              Date and time
            </p>
            <div
              class="flex gap-3 overflow-x-scroll py-6"
              v-if="timelisting().length"
            >
              <div
                class="flex-none bg-gray-150 rounded py-2 2xs:px-8 px-4"
                v-for="(obj, k) in timelisting()"
                :key="k"
              >
                <p class="text-gray-500">
                  {{ obj.date + ' ' + obj.month + ', ' + obj.year }}
                </p>
                <p class="text-gray-500">
                  {{ obj.startTime + ' - ' + obj.endTIme }}
                </p>
              </div>
            </div>
            <p
              v-if="!!event.haveCovidDetail"
              class="
                w-full
                text-green-900 text-3xl
                font-semibold
                mx-auto
                mb-6
                pt-6
              "
            >
              Covid Indicators
            </p>
            <div v-if="!!event.haveCovidDetail" class="flex gap-6 h-6">
              <div class="relative group">
                <img
                  src="/img/myle/svg/CovidAssets/ic_mask_covid.svg"
                  class="h-8"
                  alt=""
                />
                <div
                  class="
                    absolute
                    bottom-2
                    flex flex-col
                    items-center
                    hidden
                    mb-6
                    group-hover:flex
                  "
                >
                  <span
                    class="
                      relative
                      z-10
                      p-2
                      text-sm
                      leading-none
                      w-max
                      text-green-900
                      bg-lime
                      rounded-xl
                    "
                    >Mask Required</span
                  >
                  <div
                    class="absolute w-3 h-3 left-4 top-5 rotate-45 bg-lime"
                  ></div>
                </div>
              </div>
              <div class="relative group">
                <img
                  src="/img/myle/svg/CovidAssets/thermometer.svg"
                  class="h-8"
                  alt=""
                />
                <div
                  class="
                    absolute
                    bottom-2
                    -left-4
                    flex flex-col
                    items-center
                    hidden
                    mb-6
                    group-hover:flex
                  "
                >
                  <span
                    class="
                      relative
                      z-10
                      p-2
                      text-sm
                      leading-none
                      w-max
                      text-green-900
                      bg-lime
                      rounded-xl
                    "
                    >Temperature Check Required</span
                  >
                  <div
                    class="absolute w-3 h-3 left-5 top-5 rotate-45 bg-lime"
                  ></div>
                </div>
              </div>
              <div class="relative group">
                <img
                  src="/img/myle/svg/CovidAssets/ic_covidCertificate.svg"
                  class="h-8"
                  alt=""
                />
                <div
                  class="
                    absolute
                    bottom-2
                    -left-4
                    flex flex-col
                    items-center
                    hidden
                    mb-6
                    group-hover:flex
                  "
                >
                  <span
                    class="
                      relative
                      z-10
                      p-2
                      text-sm
                      leading-none
                      w-max
                      text-green-900
                      bg-lime
                      rounded-xl
                    "
                    >Vaccination Card Required</span
                  >
                  <div
                    class="absolute w-3 h-3 left-6 top-5 rotate-45 bg-lime"
                  ></div>
                </div>
              </div>
              <div class="relative group">
                <img
                  src="/img/myle/svg/CovidAssets/ic_person_covid.svg"
                  class="h-8"
                  alt=""
                />
                <div
                  class="
                    absolute
                    bottom-2
                    -left-6
                    flex flex-col
                    items-center
                    hidden
                    mb-6
                    group-hover:flex
                  "
                >
                  <span
                    class="
                      relative
                      z-10
                      p-2
                      text-sm
                      leading-none
                      w-max
                      text-green-900
                      bg-lime
                      rounded-xl
                    "
                    >Some Text here</span
                  >
                  <div
                    class="absolute w-3 h-3 left-8 top-5 rotate-45 bg-lime"
                  ></div>
                </div>
              </div>
              <div class="relative group">
                <img
                  src="/img/myle/svg/CovidAssets/ic_twopeople_covid.svg"
                  class="h-8"
                  alt=""
                />
                <div
                  class="
                    absolute
                    bottom-2
                    -left-5
                    flex flex-col
                    items-center
                    hidden
                    mb-6
                    group-hover:flex
                  "
                >
                  <span
                    class="
                      relative
                      z-10
                      p-2
                      text-sm
                      leading-none
                      w-max
                      text-green-900
                      bg-lime
                      rounded-xl
                    "
                    >Capacity</span
                  >
                  <div
                    class="absolute w-3 h-3 left-7 top-5 rotate-45 bg-lime"
                  ></div>
                </div>
              </div>
              <div class="relative group">
                <img
                  src="/img/myle/svg/CovidAssets/ic_sheild.svg"
                  class="h-8"
                  alt=""
                />
                <div
                  class="
                    absolute
                    bottom-2
                    -right-4
                    flex flex-col
                    items-center
                    hidden
                    mb-6
                    group-hover:flex
                  "
                >
                  <span
                    class="
                      relative
                      z-10
                      p-2
                      text-sm
                      leading-none
                      w-max
                      text-green-900
                      bg-lime
                      rounded-xl
                    "
                    >Safety Required</span
                  >
                  <div
                    class="absolute w-3 h-3 right-4 top-5 rotate-45 bg-lime"
                  ></div>
                </div>
              </div>
              <div class="relative group">
                <img
                  src="/img/myle/svg/CovidAssets/ic_clock_covid.svg"
                  class="h-8"
                  alt=""
                />
                <div
                  class="
                    absolute
                    bottom-2
                    right-0
                    flex flex-col
                    items-center
                    hidden
                    mb-6
                    group-hover:flex
                  "
                >
                  <span
                    class="
                      relative
                      z-10
                      p-2
                      text-sm
                      leading-none
                      w-max
                      text-green-900
                      bg-lime
                      rounded-xl
                    "
                    >Waiting Time</span
                  >
                  <div
                    class="absolute w-3 h-3 right-2 top-5 rotate-45 bg-lime"
                  ></div>
                </div>
              </div>
            </div>
            <div class="mt-16" v-if="false">
              <p class="text-gray-600">Share this event</p>
              <p class="font-light mt-3 text-md text-gray-400">
                Copy this URL to share the event. Anybody will be able to view
                the event.
              </p>
              <div
                class="w-full py-5 mt-5 border-gray-200 rounded border"
              ></div>
              <p class="font-light text-md mt-5 text-gray-400">
                Or share this event on:
              </p>
              <div class="flex gap-3 mt-3 items-center">
                <img
                  src="/img/myle/svg/social-media-icon/facebook.svg"
                  class="h-7 cursor-pointer transform hover:scale-105"
                  alt=""
                />
                <img
                  src="/img/myle/svg/social-media-icon/twitter-icon.svg"
                  class="h-7 cursor-pointer transform hover:scale-105"
                  alt=""
                />
                <img
                  src="/img/myle/svg/social-media-icon/linkedin.svg"
                  class="h-7 cursor-pointer transform hover:scale-105"
                  alt=""
                />
                <img
                  src="/img/myle/svg/social-media-icon/Group 14.svg"
                  class="h-7 cursor-pointer transform hover:scale-105"
                  alt=""
                />
              </div>
              <p class="mt-8 text-gray-400">
                <span class="text-xl text-lime">&#9872;</span>
                <a
                  href=""
                  class="text-gray-500 font-light text-md hover:text-lime"
                  >Report Event</a
                >
              </p>
            </div>
          </div>
          <div
            class="sm:flex-1 w-full sm:pl-16 mt-16 sm:mt-0 flex-initial"
            v-bind:class="{
              'wid-full': innerWidth <= 916,
              'wid-60': innerWidth > 916,
              'wid-50': innerWidth >= 1024,
            }"
          >
            <div class="flex flex-col gap-10">
              <div class="tab">
                <div
                  class="relative rounded border-lime overflow-hidden border"
                >
                  <input
                    type="checkbox"
                    id="remindMe"
                    class="
                      cursor-pointer
                      w-5
                      h-5
                      absolute
                      -z-1
                      top-0
                      opacity-0
                      hidden
                    "
                  />
                  <label
                    for="remindMe"
                    class="
                      flex
                      items-center
                      gap-5
                      w-full
                      hover:bg-gray-100
                      px-5
                      py-2
                      tab-label
                      cursor-pointer
                    "
                  >
                    <div class="flex-none">
                      <img
                        src="/img/myle/svg/set-alarm.svg"
                        class="h-5 w-10"
                        alt=""
                      />
                    </div>
                    <div class="flex-grow">
                      <span class="text-gray-500">Remind Me</span>
                    </div>
                    <div class="flex-none">
                      <i
                        class="
                          text-lime text-2xl
                          tab-arrow
                          transition-all
                          ease-linear
                          duration-500
                        "
                        v-bind:class="{
                          'fa fa-caret-up': !setReminder,
                          'fa fa-caret-down': setReminder,
                        }"
                      ></i>
                    </div>
                  </label>
                  <div
                    class="tab-content"
                    v-bind:class="{ 'height-0': setReminder }"
                  >
                    <div class="py-6 sm:px-5 px-2">
                      <p class="text-gray-400 text-sm">
                        Select Date & Time for reminder
                      </p>
                      <div class="flex gap-4 mt-5">
                        <flat-pickr
                          v-model="startDate"
                          :config="startDateConfig"
                          class="form-control flex-1 py-6 border rounded pl-2"
                          name="startDate"
                        />
                        <flat-pickr
                          v-model="endtDate"
                          :config="startDateConfig"
                          class="form-control flex-1 py-6 border rounded pl-2"
                          name="startDate"
                        />
                      </div>
                      <div class="text-center mt-6">
                        <button
                          class="
                            flex
                            items-center
                            gap-5
                            border-green-900
                            text-sm
                            sm:text-lg
                            mx-auto
                            rounded
                            py-2
                            2xs:px-8
                            px-4
                            mt-8
                            mb-2
                            border
                            bg-white
                            text-green-800
                            hover:border-green-800
                            transition
                            ease-in-out
                            duration-500
                            hover:text-white hover:bg-green-800
                          "
                        >
                          <span class="">Set Reminder</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab">
                <div
                  class="relative rounded border-lime overflow-hidden border"
                >
                  <input
                    type="checkbox"
                    id="feedback"
                    class="cursor-pointer w-5 h-5 absolute -z-1 top-0 opacity-0"
                    checked
                    @click="setRatingValue()"
                  />
                  <label
                    for="feedback"
                    class="
                      flex
                      items-center
                      gap-5
                      w-full
                      hover:bg-gray-100
                      px-5
                      py-2
                      tab-label
                      cursor-pointer
                    "
                  >
                    <div class="flex-none">
                      <img
                        src="/img/myle/svg/rating.svg"
                        class="h-5 w-10"
                        alt=""
                      />
                    </div>
                    <div class="flex-grow">
                      <span class="text-gray-500">Feedback</span>
                    </div>
                    <div class="flex-none">
                      <i
                        class="
                          text-lime text-2xl
                          tab-arrow
                          transition-all
                          ease-linear
                          duration-500
                        "
                        v-bind:class="{
                          'fa fa-caret-up': !setRating,
                          'fa fa-caret-down': setRating,
                        }"
                      ></i>
                    </div>
                  </label>
                  <div
                    class="tab-content"
                    v-bind:class="{ 'height-0': setRating }"
                  >
                    <div class="sm:w-10/12 w-11/12 mx-auto py-6">
                      <p class="text-gray-400 text-md text-center">
                        Your feedback will be visible to other MYLERs and the
                        Event Host.
                      </p>
                      <div class="mx-auto w-max">
                        <div class="rating">
                          <input
                            type="radio"
                            id="star5"
                            name="rating"
                            value="5"
                            @click="setFeedBackValue(5)"
                            checked
                          /><label class="full" for="star5"
                            ><i class="fa fa-star icon-height"></i
                          ></label>
                          <input
                            type="radio"
                            id="star4"
                            name="rating"
                            value="4"
                            @click="setFeedBackValue(4)"
                          /><label class="full" for="star4"
                            ><i class="fa fa-star icon-height"></i
                          ></label>
                          <input
                            type="radio"
                            id="star3"
                            name="rating"
                            value="3"
                            @click="setFeedBackValue(3)"
                          /><label class="full" for="star3"
                            ><i class="fa fa-star icon-height"></i
                          ></label>
                          <input
                            type="radio"
                            id="star2"
                            name="rating"
                            value="2"
                            @click="setFeedBackValue(2)"
                          /><label class="full" for="star2"
                            ><i class="fa fa-star icon-height"></i
                          ></label>
                          <input
                            type="radio"
                            id="star1"
                            name="rating"
                            value="1"
                            @click="setFeedBackValue(1)"
                          /><label class="full" for="star1"
                            ><i class="fa fa-star icon-height"></i
                          ></label>
                        </div>
                      </div>
                      <textarea
                        class="w-full border rounded h-40 border-grayline"
                        v-model="feedbackMessage"
                      ></textarea>
                      <div class="text-center">
                        <button
                          @click="sendFeedback()"
                          class="
                            text-center
                            border-green-900
                            text-sm
                            sm:text-lg
                            mx-auto
                            rounded
                            py-2
                            mt-8
                            mb-2
                            px-8
                            border
                            bg-white
                            hover:border-green-800
                            transition
                            ease-in-out
                            duration-500
                            hover:text-white hover:bg-green-800
                            text-green-800
                          "
                        >
                          Send Feedback
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        @click="show = false"
        v-if="event"
        class="
          w-full
          bg-white
          h-96
          border-t border-b border-lime
          flex
          items-center
          text-center text-xl text-gray-300
        "
      >
        <GmapMap
          ref="addressMap"
          :zoom="17"
          :center="{
            lat: Number(event.latitude),
            lng: Number(event.longitude),
          }"
          :style="`width: 100%; height: 384px; overflow: hidden;`"
          :options="exploreMapOptions"
        >
          <!--
      <GmapCircle :center="{lat: Number(event.latitude), lng: Number(event.longitude)}" :clickable="false" :draggable="false" :radius="500" :visible=true :icon="event.image1" :options="{fillColor:'black',fillOpacity:0.3, strokeOpacity: 0,clickableIcons: false}"/>
    -->
          <GmapMarker
            :position="{
              lat: Number(event.latitude),
              lng: Number(event.longitude),
            }"
            :clickable="false"
            :draggable="false"
            :icon="'/img/myle/svg/ic_pin.svg'"
          />
        </GmapMap>
      </div>
      <div
        @click="show = false"
        class="
          w-full
          text-center
          bg-white
          sm:px-0
          px-3
          border-b
          pb-12
          border-grayline
        "
      >
        <p class="font-light pt-8 uppercase text-gray-400">Venue Name</p>
        <p class="text-gray-600 mt-1 tracking-wider">{{ event.venue }}</p>
        <p class="font-light mt-5 uppercase text-gray-400">Address</p>
        <p class="text-gray-600 mt-1 tracking-wider">{{ event.address }}</p>
        <div class="text-center" @click="setWarning()">
          <a
            id="direction"
            v-bind:class="{ 'pointer-events-none': !user }"
            style="width: 9rem"
            :href="
              `${'https://maps.google.com/?saddr=Current+Location&daddr=' +
                event.latitude +
                ',' +
                event.longitude +
                '&driving'}`
            "
            target="_blank"
            class="
              flex
              items-center
              gap-5
              border-green-900
              text-sm
              sm:text-lg
              mx-auto
              btnIcon
              rounded
              p-2
              mt-8
              mb-2
              border
              bg-white
              text-green-800
              hover:border-green-800
              transition
              ease-in-out
              duration-500
              hover:text-white hover:bg-green-800
            "
          >
            <img
              src="/img/myle/svg/btn_direction_icon.svg"
              class="float-left"
              alt=""
            />
            <span class="">Directions</span>
          </a>
        </div>
        <div class="flex gap-3 mt-12 w-full" v-if="false">
          <div class="flex-1">
            <a href=""
              ><img
                src="/img/myle/svg/uberBtn.svg"
                class="h-10 float-right"
                alt=""
            /></a>
          </div>
          <div class="flex-1">
            <a href=""
              ><img
                src="/img/myle/svg/lyftBtn.svg"
                class="h-10 float-left"
                alt=""
            /></a>
          </div>
        </div>
      </div>
      <div
        @click="show = false"
        class="
          w-full
          text-center
          bg-white
          sm:px-0
          px-3
          border-b
          pb-12
          border-grayline
        "
      >
        <p
          class="
            w-full
            text-green-900 text-3xl
            font-semibold
            mx-auto
            pt-10
            border-gray-line
          "
        >
          Hosted By
        </p>
        <div class="mx-auto w-24 m-24 my-6 rounded-full overflow-hidden">
          <img
            :src="eventUserProfile(event)"
            class="w-full h-full object-cover"
            alt=""
          />
        </div>
        <p class="text-gray-600 text-lg tracking-wider">
          {{ event && event.user ? event.user.fullName : '' }}
        </p>
        <p class="font-light mt-1 text-sm text-gray-400">Joined 2 Years ago</p>
        <p class="font-light text-sm text-gray-400">
          Verified:
          {{ event.user ? (event.user.emailVerified ? 'Yes' : 'No') : '-' }}
        </p>
        <div class="text-center">
          <button
            v-if="
              event &&
                $CURRENT_USER.user &&
                $CURRENT_USER.user.userId != event.userId
            "
            @click="setFollowEvent"
            class="
              outline-0
              flex
              items-center
              gap-5
              border-green-900
              text-sm
              sm:text-lg
              mx-auto
              rounded
              py-2
              2xs:px-8
              px-4
              mt-5
              mb-2
              border
              hover:border-green-800
              transition
              ease-in-out
              duration-500
              hover:text-white hover:bg-green-800
            "
            v-bind:class="{
              'bg-green-900 text-white': followed,
              'bg-white text-green-800': !followed,
            }"
          >
            <span class="" v-if="!followed">Follow</span>
            <span class="" v-if="followed">Following</span>
          </button>
        </div>
        <div
          class="w-20 h-20 rounded-xl mx-auto mt-16 overflow-hidden"
          v-if="event.externalSource"
        >
          <img
            :src="
              `${event.externalSource ? $APP_CONFIG.BASE_IMAGE_URL : ''}${
                event.externalSource
                  ? getSource(event.externalSource).logo
                  : '/img/myle/svg/logo-nav.png'
              }`
            "
            class="w-full h-full object-contain"
            alt=""
          />
        </div>
        <p
          v-if="event.externalSource"
          class="font-light text-sm mt-3 text-gray-400"
        >
          <span class="uppercase pr-1">source:</span>
          <a href="" class="text-gray-500 tracking-wider hover:text-lime">{{
            event.externalSource ? getSource(event.externalSource).title : ''
          }}</a>
        </p>
      </div>
      <div
        @click="show = false"
        class="
          w-full
          text-center
          bg-white
          mb-24
          rounded-b-xl
          overflow-hidden
          sm:mb-16
          border-grayline
        "
      >
        <div class="relative overflow-hidden">
          <input
            type="checkbox"
            id="comment-section"
            class="cursor-pointer w-5 h-5 absolute -z-1 top-0 opacity-0 hidden"
            checked
            @click="
              setWarning();
              setComment = !setComment;
            "
          />
          <label
            for="comment-section"
            class="
              flex
              items-center
              comment-section
              gap-5
              w-full
              px-8
              py-2
              bg-lime
              cursor-pointer
            "
          >
            <div class="flex-none">
              <img
                src="/img/myle/svg/ic_tileChat.svg"
                class="h-6 w-8 filter-white"
                alt=""
              />
            </div>
            <div class="flex-grow text-left">
              <span class="text-white uppercase tracking-wider font-light"
                >Comments</span
              >
            </div>
            <div class="flex-none">
              <i
                class="
                  fa fa-caret-down fa-2x
                  text-white text-2xl
                  tab-arrow
                  transition-all
                  ease-linear
                  duration-500
                "
                v-bind:class="{
                  'fa fa-caret-up': !setComment,
                  'fa fa-caret-down': setComment,
                }"
              ></i>
            </div>
          </label>
          <div class="tab-content" v-bind:class="{ 'height-0': setComment }">
            <div class="sm:px-10 px-2 py-8 flex flex-col">
              <div class="flex w-full gap-3 pb-6">
                <div class="flex-none">
                  <div class="w-14 h-14 overflow-hidden rounded-full">
                    <img
                      :src="eventUserProfile(event)"
                      class="w-full h-full object-cover"
                      alt=""
                    />
                  </div>
                </div>
                <input
                  class="grow w-full rounded-full border px-5 border-grayline"
                  v-model="comment_reply"
                  style="outline: 0"
                  type="text"
                  placeholder="Add Comment"
                />
                <div class="flex-none">
                  <div
                    class="w-14 h-14 overflow-hidden rounded-full"
                    v-on:click="postComment()"
                  >
                    <img
                      src="/img/myle/svg/ic_chatSendBtn.svg"
                      class="w-full h-full cursor-pointer object-cover"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div class="sm:pr-16">
                <div
                  class="
                    flex
                    w-full
                    gap-3
                    relative
                    border-b
                    py-6
                    border-gray-bottom
                  "
                  v-for="comment in comments"
                >
                  <div class="flex-none">
                    <div class="w-14 h-14 overflow-hidden rounded-full">
                      <img
                        :src="eventUserProfile(comment)"
                        class="w-full cursor-pointer h-full object-cover"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="flex-grow text-left">
                    <h1 class="text-green-800 cursor-pointer font-medium">
                      {{ comment && comment.user ? comment.user.fullName : '' }}
                    </h1>
                    <p class="text-gray-500 font-light pt-1 pr-3">
                      {{ comment.commentText }}
                    </p>
                  </div>
                  <div class="flex-none relative">
                    <div
                      :data-key="comment.id"
                      @click="toggleModel(comment)"
                      class=" menuu"
                    >
                      <img
                        :data-key="comment.id"
                        src="/img/myle/svg/more.svg"
                        class="h-5 cursor-pointer m-1 menuu"
                        alt=""
                        v-bind:class="{ hidden: false }"
                      />
                    </div>
                    <div
                      class="
                        bg-white
                        w-20
                        rounded
                        p-1
                        absolute
                        z-20
                        right-2
                        top-1
                        shadow-box
                        flex-col
                        menuu
                      "
                      :id="comment.id"
                      v-bind:class="{
                        hidden: !showcomment[comment.id],
                        block: showcomment[comment.id],
                      }"
                    >
                      <div
                        :data-key="comment.id"
                        class="
                          text-gray-500
                          p-1
                          text-sm
                          cursor-pointer
                          hover:text-green-800
                          truncate

                        "
                        @click="toggleModel(comment)"
                      >
                        Delete
                      </div>
                      <div
                        :data-key="comment.id"
                        class="
                          text-gray-500
                          p-1
                          text-sm
                          cursor-pointer
                          hover:text-green-800
                          truncate
                          hidden
                        "
                        @click="toggleModel(comment)"
                      >
                        Option 2
                      </div>
                    </div>
                  </div>
                  <div class="absolute top-6 right-6">
                    <p class="text-gray-400 text-sm z-10 font-extralight pt-1">
                      {{ comment.createdAt | moment('MMM DD, YYYY | hh:mm A') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="py-5 w-full"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topnavbar from '../views/Topnavbar';
import { mapActions, mapState } from 'vuex';
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import config from '@/config/config';
import { userService } from '../services/user.service';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import VueElementLoading from 'vue-element-loading';
import { userHelper } from '../helpers/user-helper';
import { VueFinalModal } from 'vue-final-modal';
import unauthorizedUser from './unauthorizedUser/unauthorizedUser.vue';
import privateEvent from './privateEvent/privateEvent.vue';
import { utcToSystemFixedLocal } from '../config/time';

export default {
  name: 'event-detail',
  components: {
    topnavbar,
    flatPickr,
    VueElementLoading,
    VueFinalModal,
    unauthorizedUser,
    privateEvent,
    'gmap-custom-marker': GmapCustomMarker,
  },
  data() {
    return {
      affid: null,
      passcodeVerify: false,
      showModel: false,
      show: false,
      innerWidth: 960,
      followed: false,
      showStickyNav: false,
      feedbackMessage: '',
      feedbackRating: 5,
      showcomment: {},
      comment_reply: '',
      loadStyle: {
        color: '#ffffff',
        'font-weight': 'bold',
        'letter-spacing': '1rem',
        'font-size': '18px',
      },
      startDateConfig: {
        altFormat: 'M j, Y G:i K',
        altInput: true,
        dateFormat: 'Y-m-d G:i K',
        enableTime: true,
        onClose: () => {},
        onOpen: () => {},
      },
      endtDate: new Date(),
      startDate: new Date(),
      setReminder: true,
      setComment: false,
      setRating: false,
      exploreMapOptions: {
        clickableIcons: false,
        streetViewControl: false,
        mapTypeControl: false,
        styles: [],
      },
      isLoading: false,
      isLoggedIn: false,
    };
  },
  watch: {
    user: function(nn) {
      if (nn && nn.id) {
        const regLink = localStorage.getItem('recentregLink');
        if (regLink) {
          this.$toast.success('You are logged In now.', { timeout: 4000 });
          localStorage.removeItem('recentregLink');
          this.isLoading = false;
        }
      }
    },
    eventStatus: function(Status) {
      this.isLoading = Status;

      if (!Status && this.$CURRENT_USER && this.$CURRENT_USER.user) {
        this.followed =
          this.$CURRENT_USER.user.followings.filter(
            (x) => x.followedUserId == this.event.userId
          ).length > 0;
      }
    },
  },
  computed: {
    ...mapState('account', ['user']),
    ...mapState('events', [
      'eventStatus',
      'event',
      'events',
      'comments',
      'categories',
      'services',
    ]),
    getZoneName() {
      const d = new Date();
      d.setDate(15);
      d.setMonth(0);
      return d
        .toLocaleDateString('en-us', { day: '2-digit', timeZoneName: 'long' })
        .substring(4)
        .match(/\b(\w)/g)
        .join('');
    },
    returnUrl() {
      if (!this.event) {
        return null;
      }
      if (
        this.$route &&
        this.$route.query &&
        this.$route.query.affid &&
        this.$route.query.affid.trim().length > 0
      ) {
        this.affid = this.$route.query.affid.trim();
      }

      if (
        !this.event.haveTicket &&
        (this.event.ticketUrl || '').length == 0 &&
        Number(this.event.totalMYLETickets) == 0
      ) {
        return null;
      } else if (
        this.event.haveTicket &&
        (this.event.ticketUrl || '').length == 0 &&
        Number(this.event.totalMYLETickets) > 0
      ) {
        return (
          'https://web.myle.com/ticket/' +
          this.event.eventCode +
          (this.affid ? '?affid=' + this.affid : '')
        );
      } else if (
        this.event.haveTicket &&
        (this.event.ticketUrl || '').length != 0 &&
        Number(this.event.totalMYLETickets) == 0
      ) {
        return this.event.ticketUrl;
      } else if (
        this.event.haveTicket &&
        (this.event.ticketUrl || '').length != 0 &&
        Number(this.event.totalMYLETickets) > 0
      ) {
        return (
          'https://web.myle.com/ticket/' +
          this.event.eventCode +
          (this.affid ? '?affid=' + this.affid : '')
        );
      }
      return null;
    },
    isPresenterPresent() {
      if (
        this.$CURRENT_USER &&
        this.$CURRENT_USER.user &&
        this.$CURRENT_USER.user.presenter &&
        this.$CURRENT_USER.user.presenter.trim().length > 0 &&
        this.$CURRENT_USER.user.presenter != 'null'
      ) {
        return true;
      }

      return false;
    },
    eventStatusVal() {
      if (this.event.isRecurring) {
        if (
          new Date().getTime() < new Date(this.event.startDateTime).getTime()
        ) {
          return 'UPCOMING';
        } else {
          return 'RECURRING';
        }
      } else {
        if (
          new Date().getTime() < new Date(this.event.startDateTime).getTime()
        ) {
          return 'UPCOMING';
        } else {
          return 'ON-GOING';
        }
      }
    },
    mappedCategories() {
      return this.categories.filter(
        (val) =>
          (this.event.categories || []).includes(val.id) ||
          (this.event.categories || []).includes(val.id.toString())
      );
    },
  },
  methods: {
    ...mapActions('account', ['followUser', 'unfollowUser']),
    ...mapActions('events', [
      'getEventDetails',
      'getEventComments',
      'getCategories',
      'likEvent',
      'unLikeEvent',
      'loveEvent',
      'unLoveEvent',
      'attendEvent',
      'unAttendEvent',
      'postUserComment',
      'getServices',
      'postFeedback',
    ]),
    setID(i) {
      return 'c' + i;
    },
    toLocalNoDST(utcTs, format) {
      // Fixed local using yearly daylight offset (e.g., EDT for US Eastern)
      return utcToSystemFixedLocal(utcTs, {
        outputFormat: format,
      });
    },
    offsetDiff(ev, format) {
      const dt = ev.startDateTime || this.$moment();
      return this.toLocalNoDST(dt, format);
    },
    offsetDiffe(ev, f) {
      const dt = ev.endDateTime;
      return this.toLocalNoDST(dt, f);
    },
    clipboard(e, evnt) {
      e.stopPropagation();
      if (evnt) {
        navigator.clipboard.writeText(evnt.eventCode);
        this.$toast.success('Event code copied', { timeout: 4000 });
      }
    },
    passcodeVerified() {
      this.passcodeVerify = true;
    },
    getYears() {
      if (
        new Date().getFullYear() -
          new Date(event.user.createdAt).getFullYear() >
        0
      ) {
        return (
          new Date().getFullYear() -
          new Date(event.user.createdAt).getFullYear() +
          ' year(s) ago'
        );
      } else if (12 - new Date(event.user.createdAt).getMonth() + 1 > 0) {
        return (
          12 - new Date(event.user.createdAt).getMonth() + 1 + ' month(s) ago'
        );
      }

      return 'Joined this year';
    },
    toggle(value) {
      this.show = value;
    },
    setRatingValue() {
      if (!this.user) {
        this.showModel = true;
        // this.$toast.warning("please login before continuing the operation", { timeout: 4000});
        return true;
      } else {
        this.setRating = !this.setRating;
      }
    },
    setFeedBackValue(v) {
      this.feedbackRating = v;
    },
    findUrls(text = '') {
      const urlRegex = /(\b(https?|ftp|file|http):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      const changedData = text.replace(urlRegex, (url) => {
        return `<a style='color:#B3CF38' href=${url}>${url}</a>`;
      });

      const urlRegex1 = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi;
      const changedData1 = changedData.replace(urlRegex1, (url) => {
        return `<a href="mailto:${url}" style='color:#B3CF38'>${url}</a>`;
      });

      return changedData1;
    },
    setWarning(noValidation) {
      if (noValidation) {
        return;
      }
      if (!this.user) {
        this.showModel = true;
        // this.$toast.warning("please login before continuing the operation", { timeout: 4000});
      }
      return;
    },
    sendFeedback() {
      if (!this.user) {
        this.showModel = true;
        return;
      }

      document.getElementById('star1').checked = false;
      document.getElementById('star2').checked = false;
      document.getElementById('star3').checked = false;
      document.getElementById('star4').checked = false;
      document.getElementById('star5').checked = false;

      this.postFeedback({
        userId: this.$CURRENT_USER.getUserId(),
        eventId: this.event.eventCode,
        stars: this.feedbackRating,
        text: this.feedbackMessage,
        eventTitle: this.event.title,
        reviewedUserId: this.event.user.id,
      })
        .then((res) => {
          this.feedbackRating = 0;
          this.feedbackMessage = '';
          this.$toast.success('Feedback Posted', { timeout: 4000 });
        })
        .catch((err) => {
          this.$toast.error('Feedback submission failed', { timeout: 4000 });
          this.feedbackRating = 0;
          this.feedbackMessage = '';
        });
    },
    getSource(s) {
      return this.services.filter((v) => v.serviceCode === s)[0];
    },
    toggleModel(comment) {
      this.showcomment[comment.id] = this.showcomment[comment.id]
        ? false
        : true;

      this.showcomment = JSON.parse(JSON.stringify(this.this.showcomment));
    },
    postComment() {
      if (!this.user) {
        this.showModel = true;
        //  this.$toast.warning("please login before continuing the operation", { timeout: 4000});
        return;
      }
      if (
        !this.user ||
        !this.comment_reply ||
        !this.comment_reply.trim().length
      ) {
        return;
      }

      this.event.totalCommentCount = parseInt(this.event.totalCommentCount) + 1;
      this.$toast.success('Comment Posted', { timeout: 4000 });

      this.postUserComment({
        userId: this.$CURRENT_USER.getUserId(),
        eventId: this.event.eventCode,
        commentText: this.comment_reply,
      });
      this.comment_reply = '';
    },
    filteredTickets() {
      let type = this.activeTicketStep;
      return this.event.tickets.filter((item) => item.type === type);
    },
    loadEvent(id) {
      this.isLoading = true;
      const params = {
        eventCode: id,
        userId: '',
      };
      if (this.$CURRENT_USER.getUserId()) {
        params.userId = this.$CURRENT_USER.getUserId();
        this.isLoggedIn = true;
      }
      this.getEventDetails(params);
      this.getEventComments({ eventId: id });
    },
    eventUserProfile(event) {
      if (!event || !event.user || !event.user.profilePicture) {
        return '';
      }
      return this.$APP_CONFIG.BASE_IMAGE_URL + event.user.profilePicture;
    },
    attendingClicked(e) {
      if (!this.user) {
        this.showModel = true;
        //  this.$toast.warning("please login before continuing the operation", { timeout: 4000});
        return;
      }
      e.preventDefault();
      if (this.event.isAttendingByUser) {
        this.event.isAttendingByUser = 0;
        this.event.totalAttendingsCount =
          parseInt(this.event.totalAttendingsCount) - 1;
        this.unAttendEvent({
          userId: this.user.userRefId,
          eventId: this.event.eventCode,
          latitude: this.user.latitude,
          longitude: this.user.longitude,
        });
      } else {
        this.event.isAttendingByUser = 1;
        this.event.totalAttendingsCount =
          parseInt(this.event.totalAttendingsCount) + 1;
        this.attendEvent({
          userId: this.user.userId,
          eventId: this.event.eventCode,
          latitude: this.user.latitude,
          longitude: this.user.longitude,
          miles: this.user.radius,
        });
      }
    },
    loveClicked(e) {
      if (!this.user) {
        this.showModel = true;
        //    this.$toast.warning("please login before continuing the operation", { timeout: 4000});
        return;
      }
      e.preventDefault();
      if (this.event.isLovedByUser) {
        this.event.isLovedByUser = 0;
        this.event.totalLovedCount = parseInt(this.event.totalLovedCount) - 1;

        this.unLoveEvent({
          userId: this.user.userId,
          eventId: this.event.eventCode,
          latitude: this.user.latitude,
          longitude: this.user.longitude,
          miles: this.user.radius,
        });
      } else {
        this.event.isLovedByUser = 1;
        this.event.totalLovedCount = parseInt(this.event.totalLovedCount) + 1;

        this.loveEvent({
          userId: this.user.userId,
          eventId: this.event.eventCode,
          latitude: this.user.latitude,
          longitude: this.user.longitude,
          miles: this.user.radius,
        });
      }

      if (this.event.isLikedByUser && this.event.isLovedByUser) {
        this.event.totalLikesCount -= 1;
        this.event.isLikedByUser = 0;
      }
    },
    likeClicked(e) {
      if (!this.user) {
        this.showModel = true;
        //    this.$toast.warning("please login before continuing the operation", { timeout: 4000});
        return;
      }

      e.preventDefault();
      if (this.event.isLikedByUser) {
        this.event.isLikedByUser = 0;
        this.event.totalLikesCount = parseInt(this.event.totalLikesCount) - 1;

        this.unLikeEvent({
          userId: this.user.userId,
          eventId: this.event.eventCode,
          latitude: this.user.latitude,
          longitude: this.user.longitude,
          miles: this.user.radius,
        });
      } else {
        this.event.isLikedByUser = 1;
        this.event.totalLikesCount = parseInt(this.event.totalLikesCount) + 1;

        this.likEvent({
          userId: this.user.userId,
          eventId: this.event.eventCode,
          latitude: this.user.latitude,
          longitude: this.user.longitude,
          miles: this.user.radius,
        });
      }

      if (this.event.isLikedByUser && this.event.isLovedByUser) {
        this.event.totalLovedCount -= 1;
        this.event.isLovedByUser = 0;
      }
    },
    handleScroll(ev) {
      const x = document.getElementById('banner');
      this.showStickyNav = window.scrollY > x.clientHeight;
    },
    timelisting() {
      if (!this.event || !this.event.startDateTime || !this.event.endDateTime) {
        return [];
      }

      let startDate = this.event.startDateTime;
      const endDate = this.event.endDateTime;
      const nextDates = [];
      let startTime = '';
      let endTIme = '';
      let count = 0;

      while (count !== 7) {
        startDate = this.$moment(startDate)
          .add(1, 'days')
          .format('YYYY-MM-DD');
        startTime = '';
        endTIme = '';

        if (
          this.$moment(startDate).format('ddd') == 'Mon' &&
          this.event.mondayStartTime &&
          this.event.mondayEndTime
        ) {
          startTime = this.event.mondayStartTime;
          endTIme = this.event.mondayEndTime;
        } else if (
          this.$moment(startDate).format('ddd') == 'Tue' &&
          this.event.tuesdayStartTime &&
          this.event.tuesdayEndTime
        ) {
          startTime = this.event.tuesdayStartTime;
          endTIme = this.event.tuesdayEndTime;
        } else if (
          this.$moment(startDate).format('ddd') == 'Wed' &&
          this.event.wednesdayStartTime &&
          this.event.wednesdayEndTime
        ) {
          startTime = this.event.wednesdayStartTime;
          endTIme = this.event.wednesdayEndTime;
        } else if (
          this.$moment(startDate).format('ddd') == 'Thu' &&
          this.event.thursdayStartTime &&
          this.event.thursdayEndTime
        ) {
          startTime = this.event.thursdayStartTime;
          endTIme = this.event.thursdayEndTime;
        } else if (
          this.$moment(startDate).format('ddd') == 'Fri' &&
          this.event.fridayStartTime &&
          this.event.fridayEndTime
        ) {
          startTime = this.event.fridayStartTime;
          endTIme = this.event.fridayEndTime;
        } else if (
          this.$moment(startDate).format('ddd') == 'Sat' &&
          this.event.saturdayStartTime &&
          this.event.saturdayEndTime
        ) {
          startTime = this.event.saturdayStartTime;
          endTIme = this.event.saturdayEndTime;
        } else if (
          this.$moment(startDate).format('ddd') == 'Sun' &&
          this.event.sundayStartTime &&
          this.event.sundayEndTime
        ) {
          startTime = this.event.sundayStartTime;
          endTIme = this.event.saturdayEndTime;
        }

        if (startTime && endTIme) {
          nextDates.push({
            date: this.$moment(startDate).format('ddd'),
            month: this.$moment(startDate).format('MMM'),
            year: this.$moment(startDate).format('YY'),
            startTime: this.$moment(startTime, 'HH:mm:ss').format('hh:mm A'),
            endTIme: this.$moment(endTIme, 'HH:mm:ss').format('hh:mm A'),
          });
        }

        count++;
      }

      return nextDates;
    },
    setFollowEvent() {
      if (!this.user) {
        this.showModel = true;
        //    this.$toast.warning("please login before continuing the operation", { timeout: 4000});
        return;
      }

      var vm = this;
      const arr =
        this.$CURRENT_USER && this.$CURRENT_USER.user
          ? this.$CURRENT_USER.user.followings.map((x) => x.followedUserId)
          : [];
      if (
        this.$CURRENT_USER &&
        this.$CURRENT_USER.user &&
        arr.includes(this.event.userId)
      ) {
        this.unfollowUser({
          followerUserId: this.$CURRENT_USER.user.userId,
          followedUserId: this.event.userId,
        }).then((res) => {
          let userSession = localStorage.getItem('user');

          if (userSession && !res.error) {
            userSession = JSON.parse(userSession);
            userSession.followings = res;
            localStorage.setItem('user', JSON.stringify(userSession));
            vm.$toast.success('Unfollowed successfully', { timeout: 4000 });

            setTimeout(() => {
              this.followed = false;
              this.$CURRENT_USER.getUser();
            }, 100);
          } else {
            vm.$toast.error('Request Failed', { timeout: 4000 });
          }
        });
      } else if (
        this.$CURRENT_USER &&
        this.$CURRENT_USER.user &&
        !arr.includes(this.event.userId)
      ) {
        this.followUser({
          followerUserId: this.$CURRENT_USER.user.userId,
          followedUserId: this.event.userId,
        }).then((res) => {
          let userSession = localStorage.getItem('user');

          if (userSession && !res.error) {
            userSession = JSON.parse(userSession);
            userSession.followings = res;
            localStorage.setItem('user', JSON.stringify(userSession));
            vm.$toast.success('Followed successfully', { timeout: 4000 });
            setTimeout(() => {
              this.followed = true;
              this.$CURRENT_USER.getUser();
            }, 100);
          } else {
            vm.$toast.error('Request Failed', { timeout: 4000 });
          }
        });
      }
    },
    resizePage() {
      this.innerWidth = window.innerWidth;
    },
    closeModel() {
      this.showModel = false;
    },
    setLoader(v) {
      if (v) {
        this.isLoading = true;
      } else if (!v) {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.$CURRENT_USER.getUser();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.resizePage);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.resizePage);
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    if (
      this.$route &&
      this.$route.query &&
      this.$route.query.affid &&
      this.$route.query.affid.trim().length > 0
    ) {
      this.affid = this.$route.query.affid.trim();
    }

    this.innerWidth = window.innerWidth;
    this.getCategories();
    this.getServices();
    this.loadEvent(this.$route.params.id);

    if (this.$route.params.id == 'g6OHvPsu74BRdx') {
      window.open('http://22foundation.myle.com', '_self');
    }

    window.onclick = (ev) => {
      const v = ev.target.classList[ev.target.classList.length - 1];
      const vv = document.getElementsByClassName(
        'bg-white w-20 rounded p-1 absolute z-20 right-2 top-1 shadow-box flex-col'
      );
      if (vv.length) {
        for (var ele = 0; ele < vv.length; ele++) {
          if (!vv[ele].classList.contains('hidden')) {
            vv[ele].classList.toggle('hidden');
          }
        }
      }

      const e = document.getElementById(ev.target.getAttribute('data-key'));

      if (v.includes('menuu')) {
        e.classList.toggle('hidden');
      }
    };
  },
};
</script>
<style scoped>
input[type='checkbox'] + label::before,
input[type='checkbox']:checked + label::after {
  opacity: 0 !important;
}

.height-0 {
  height: 0 !important;
}

.icon-height {
  font-size: 1.5rem !important;
}

button:hover,
#direction:hover {
  color: white !important;
}

.background-overlay {
  background: #114436c4 !important;
}

.outline-0 {
  outline: none !important;
}

.fa-calendar:before {
  content: '\f073' !important;
  font-size: 1rem;
  margin-right: 0.3rem;
}

.bg-opacity-40 {
  background-color: rgba(179, 207, 56, 0.4) !important;
}

.outer-div {
  height: 60vh !important;
}
.inner-div {
  height: 45vh !important;
}

@media screen and (max-width: 480px) {
  .fsize {
    font-size: 1.7rem !important;
  }
}

@media screen and (min-width: 480px) and (max-width: 699px) {
  .outer-div {
    height: 65vh !important;
  }
  .inner-div {
    height: 50vh !important;
  }
  .fsize {
    font-size: 2rem !important;
  }
}

@media screen and (min-width: 700px) {
  .outer-div {
    height: 65vh !important;
  }
  .inner-div {
    height: 50vh !important;
  }
}

@media screen and (min-width: 850px) {
  .outer-div {
    height: 65vh !important;
  }
  .inner-div {
    height: 50vh !important;
  }
}

@media screen and (min-width: 1080px) {
  .outer-div {
    height: 65vh !important;
  }
  .inner-div {
    height: 50vh !important;
  }
}

.wid-full {
  width: 100% !important;
}

.wid-30 {
  width: 30% !important;
}

.wid-40 {
  width: 40% !important;
}

.wid-50 {
  width: 40% !important;
}

.wid-60 {
  width: calc(60% - 6rem) !important;
}

.wid-70 {
  width: 70% !important;
}

.pointer-events-none {
  pointer-events: none;
}

::v-deep .modal-container1 {
  display: block;
  overflow: hidden;
  align-items: center;
  background: white;
  border-radius: 0.25rem;
  margin: auto;
  margin-bottom: auto;
  max-width: 700px;
  overflow-y: scroll;
  height: 660px;
}

::v-deep .modal-content1 {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-radius: 0.25rem;
  background: #fff;
}

::v-deep .modal-container3 {
  display: block;
  overflow: hidden;
  align-items: center;
  background: white;
  border-radius: 0.25rem;
  margin: auto;
  margin-bottom: auto;
  max-width: 700px;
  height: 380px;
}

::v-deep .modal-content3 {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-radius: 0.25rem;
  background: #fff;
}
</style>
